import { responseArray, authHeaders } from './apiFetch';

export const getWishlistLength = async() => {
    try {
        const response = await fetch('/api/user/wishlist', {
            headers: authHeaders()
        });
        if (response.ok) {
            const results = await response.json();
            return responseArray(results, 'wishlist').length;
        } else {
            console.error('Failed to fetch updated wishlist length');
        }
    } catch (error) {
        console.error('Error fetching updated wishlist length:', error);
    }
    return 0;
}
